<script setup>
import { themes } from '@/plugins/vuetify/theme'
import ChatActiveChatUserProfileSidebarContent from '@/views/apps/chat/ChatActiveChatUserProfileSidebarContent.vue'
import ChatLeftSidebarContent from '@/views/apps/chat/ChatLeftSidebarContent.vue'
import ChatLog from '@/views/apps/chat/ChatLog.vue'
import ChatMessageForm from '@/views/apps/chat/ChatMessageForm.vue'
import ChatUserProfileSidebarContent from '@/views/apps/chat/ChatUserProfileSidebarContent.vue'
import { useChat } from '@/views/apps/chat/useChat'
import { useChatStore } from '@/views/apps/chat/useChatStore'
import { useNotificationStore } from '@/stores/notifications'
import { computed, getCurrentInstance } from 'vue'
import { PerfectScrollbar } from 'vue3-perfect-scrollbar'
import { useDisplay, useTheme } from 'vuetify'

import ConnectionLostDialog from '@/components/dialogs/ConnectionLostDialog.vue'
import DuplicateClientDialog from '@/components/dialogs/DuplicateClientDialog.vue'
import BotsController from '@/Controller/bots'
import { useRoute } from 'vue-router'

import chatLogo from '@/assets/images/chat-logo-2.png'
import LlmBotsController from '@/Controller/llmBots'
import ChatRecommendations from '@/views/apps/chat/ChatRecommendations.vue'

definePage({
  meta: {
    action: 'read',
    subject: 'bots',
    useBotNav: true,
    useChatNav: true,
    layoutWrapperClasses: 'layout-content-height-fixed',
  },
})

const props=defineProps({
  minimumMode:{
    type: Boolean,
    required: false,
    default: false,
  },
  bgColor: {
    type: String,
    required: false,
    default: '',
  },
})

// Get the bot ID from the route params
const route = useRoute()

// composables
const vuetifyDisplays = useDisplay()
const store = useChatStore()
const notificationStore = useNotificationStore()
const proxy = getCurrentInstance().proxy

const botId = route.params.id 
const bot = await BotsController.getBot(botId)

store.currentBot=bot

if(store.activeContactId!=bot.userId){
  store.activeContactId=bot.userId
  store.fetchChatsAndContacts('', null, bot.userId)
}

console.log('store current bot',store.currentBot)
const { isLeftSidebarOpen } = useResponsiveLeftSidebar(vuetifyDisplays.smAndDown)
const { resolveAvatarBadgeVariant } = useChat()

// Perfect scrollbar
const chatLogPS = ref()

const scrollToBottomInChatLog = () => {
  const scrollEl = chatLogPS.value?.$el || chatLogPS.value
  if (scrollEl)
    scrollEl.scrollTop = scrollEl?.scrollHeight
}

const scrollToTopInChatLog = () => {
  const scrollEl = chatLogPS.value?.$el || chatLogPS.value
  if (scrollEl)
    scrollEl.scrollTop = 0
}

const messageSent = () => {
  nextTick(async () => {
    scrollToBottomInChatLog()
  })
}

// Search query
const q = ref('')

// watch(q, val => store.fetchChatsAndContacts(val, null, bot.userId), { immediate: true })

// Open Sidebar in smAndDown when "start conversation" is clicked
// Chat message

const openChatOfContact = async chat => {
  console.log('opening chat of contact', chat)
  let chatId = chat.id
  let userId = chat.contactId

  //await store.getChat(userId)
  // console.log(store.chatsContacts)
  await store.getChat(userId, chatId)

  // Reset message input
  // msg.value = ''

  // Set unseenMsgs to 0
  const contact = store.chatsContacts.find(c => c.id === userId)
  if (contact)
    contact.chat.unseenMsgs = 0

  // if smAndDown =>  Close Chat & Contacts left sidebar
  if (vuetifyDisplays.smAndDown.value)
    isLeftSidebarOpen.value = false

  // Scroll to bottom
  nextTick(() => {
    scrollToTopInChatLog()
  })
  console.log('userId', userId)

  //Notify the recipient that you have seen their message
  if (store.activeChat?.contact?.id)
    store.wsService.sendMessage({
      type: 'gotAllMsgs',
      senderId: store.profileUser?.id,
      receiverId: store.activeChat?.contact?.id,

      // senderId: responseData.msg.senderId,
      // receiverId: responseData.msg.receiverId,
    })
}

// await openChatOfContact(bot.userId)
// await store.fetchChatsAndContacts()

// User profile sidebar
const isUserProfileSidebarOpen = ref(false)

// Active chat user profile sidebar
const isActiveChatUserProfileSidebarOpen = ref(false)

// file input
const refInputEl = ref()
const { name } = useTheme()

const chatContentContainerBg = computed(() => {
  let color = 'transparent'
  if (themes)
    color = themes?.[name.value].colors?.background

  return color
})

const streamResult = ref(null)

const handleWebSocketIncommingMessages = async event => {
  // console.log('recieved event', event.data)

  // const responseData=JSON.parse(event.data)

  let responseData = event.data
  if (
    typeof event.data === 'string' &&
    (event.data.trim().startsWith('{') || event.data.trim().startsWith('['))
  ) {
    responseData = JSON.parse(event.data)
  }


  if (responseData.msg?.eventType == 'close-duplicate') {
    console.log('closing duplicate connection')
    duplicateClientOpened.value = true
    store.wsService.close()
    return
  }

  if (responseData.type === 'notification') {
    console.log('notification received', responseData.notification)
    // notificationStore.notifications.push(responseData.notification)
    notificationStore.fetchNotifications()
  }

  //if i'm the sender and my message is seen by receiver, update message status
  if (responseData.type === 'status_update')
    store.updateMessageStatus(responseData.messageId, responseData.status)

  //if i'm the sender and my message is seen by receiver, update message status
  if (responseData.type === 'gotAllMsgs')

    //store.getChat(responseData.senderId)
    store.getChat(responseData.senderId, store.chatsContacts.value[0].chat.id)


  if (responseData?.msg) {
    if(responseData.msg?.eventType==='thinking')
      store.thinking=responseData.msg
    // console.log('responseData.msg.eventType', responseData.msg.eventType)
    if (
      responseData.msg?.eventType === 'noStream' ||
      responseData.msg?.eventType === 'feedback-mode' ||
      responseData.msg?.eventType === 'developer-mode' ||
      responseData.msg?.eventType === 'chart-generation' ||
      responseData.msg?.eventType==='table-generation' ||
      responseData.msg?.eventType==='recommendations'
    ) {

      // console.log('responseData', responseData)
      await store.showMsg(responseData)
      if( responseData.msg.type==8 && store.isMaximizeMode)
        store.maximizedChart=structuredClone(responseData.msg.message)

    }

    if (responseData.msg?.eventType === 'streamStart') {
      streamResult.value = null
      store.updateMessageID("00000000-0000-0000-0000-000000000000", "5")

      responseData.msg.eventType = 'streaming'
      // responseData.msg.message = proxy.$t('please wait')
      store.showMsg(responseData)
    }
    else if (responseData.msg?.eventType === 'streaming') {

      if (streamResult.value == null){
        streamResult.value = responseData
        // console.log('showing message...',responseData)
        // await store.showMsg(responseData)
      }
      else
        streamResult.value.msg.message += responseData.msg.message
      
      // var storedMessage=store.getMessageById(responseData.msg.id)
      // if(storedMessage==undefined){
      //   await store.showMsg(responseData)
      // }
      store.updateMessageContent(responseData.msg.id, streamResult.value?.msg)

      

    } else if (responseData.msg?.eventType === 'streamEnd') {

      store.updateMessageContent(responseData.msg.id, streamResult.value?.msg)
      await store.updateMessageEventType(responseData.msg.id, 'streamEnd')


      // store.showMsg(streamResult.value)
      // streamResult.value = null
    }

    nextTick(async () => {
      scrollToBottomInChatLog()
    })

    //update Chats and Contacts if current chat is not the same as the sender
    if (store.activeChat?.contact?.id != responseData?.msg?.senderId && store.activeChat?.chat?.messages?.length<=1){
      store.fetchChatsAndContacts('', null, store.activeChat?.contact?.id)
    }

    // Send seen acknowledgment
    // console.log(responseData?.msg?.senderId, '==',  store.activeChat?.contact?.id)
    if (responseData?.msg?.senderId == store.activeChat?.contact?.id
      && (responseData.msg?.eventType === 'streamEnd' || responseData.msg?.eventType === 'noStream')
    ) {
      console.log('sending seen_ack to sender')
      store.wsService.sendMessage({
        type: 'seen_ack',
        messageId: responseData.msg.id,
        status: 'Seen',
        senderId: responseData.msg.receiverId,
        receiverId: responseData.msg.senderId,

        // senderId: responseData.msg.senderId,
        // receiverId: responseData.msg.receiverId,
      })
    }
  }

  // Handle incoming messages

  // store.activeChat?.messages?.push(responseData.Message)
}

const newConversation = async () => {
  await store.newChat(bot.userId)
  scrollToTopInChatLog()
}

const recommends=ref([])

// const isConnectionLost =computed(()=>!store.wsService.isConnected())
const isConnectionLost = ref(!store.wsService.isConnected())
const connectingToSocket = ref(false)
const duplicateClientOpened = ref(false)

const reconnectTimer = ref(0)
const maxReconnectTime = 10 // 10 seconds

const handleReconnectTimer = () => {
  reconnectTimer.value = maxReconnectTime

  const countdownInterval = setInterval(() => {
    reconnectTimer.value--
    if (reconnectTimer.value <= 0) {
      clearInterval(countdownInterval)
      connectToSocke()
    }
  }, 1000)
}

// Immediately try to reconnect when user clicks the reconnect button
const handleManualReconnect = () => {
  reconnectTimer.value = 0
  connectToSocke()
}

const connectionAttempts=ref(0)

const connectToSocke = () => {
  console.log('try to connecting to socket')
  if (!store?.wsService?.isConnected() && isConnectionLost.value) {
    console.log('connecting to socket')
    connectingToSocket.value = true
    connectionAttempts.value++
    store.wsService.connect()
    store.wsService.ws.onmessage = handleWebSocketIncommingMessages

    store.wsService.ws.onopen = () => {
      isConnectionLost.value = false
      connectingToSocket.value = false
      connectionAttempts.value=0
    }
    
    store.wsService.ws.onclose = () => {
      if (!duplicateClientOpened.value) {
        console.log('ws disconnected')
        console.log('store.wsService', store.wsService)
        isConnectionLost.value = true
        
        if(connectionAttempts.value == 0){
          connectToSocke()
          
          return
        }

        handleReconnectTimer()
      }
    }

    store.wsService.ws.onerror = () => {
      console.log('error on web socket')
      isConnectionLost.value = true
      connectingToSocket.value = false
    }
  }
}

onMounted(async() => {

  console.log('isMaximizeMode',store.isMaximizeMode)
  
  if(store.isMaximizeMode===undefined){
    
    // console.log('unMounting bot chat page',store.isMaximizeMode , store.activeContactId,store.currentBot.userId)
    // if(store.activeContactId == null  || store.activeContactId != store.currentBot.userId)
      store.clearActiveChat()
    connectToSocke()
    recommends.value=await LlmBotsController.getrecommends(bot.llmBotId)
    // console.log('recommends:', recommends.value)
  }
  // console.log('changing isMaximizeMode to false')
  // store.isMaximizeMode=false

  
  
})

onUnmounted(() => {
  if(store.isMaximizeMode==undefined){
    store.wsService.disconnect()
  }
})

watch(()=>store.openChatFunctionTrigger, newVal =>{
  console.log('open chat triggered', newVal)
  openChatOfContact(newVal)
})

watch(()=>store.newConversationFunctionTrigger,  newVal =>{
  console.log('new conversation triggered',newVal)
  newConversation()
})
</script>

<template>
  <VLayout class="" style="z-index: 0">
    <!-- 👉 user profile sidebar -->
    <VNavigationDrawer v-model="isUserProfileSidebarOpen" data-allow-mismatch temporary touchless absolute
      class="user-profile-sidebar" location="start" width="370">
      <ChatUserProfileSidebarContent @close="isUserProfileSidebarOpen = false" />
    </VNavigationDrawer>

    <!-- 👉 Active Chat sidebar -->
    <VNavigationDrawer v-model="isActiveChatUserProfileSidebarOpen" data-allow-mismatch width="374" absolute temporary
      location="end" touchless class="active-chat-user-profile-sidebar">
      <ChatActiveChatUserProfileSidebarContent @close="isActiveChatUserProfileSidebarOpen = false" />
    </VNavigationDrawer>

    <!-- 👉 Left sidebar   -->
    <!-- <VNavigationDrawer v-model="isLeftSidebarOpen" data-allow-mismatch absolute touchless location="start" width="300"
      :temporary="$vuetify.display.smAndDown" class="chat-list-sidebar" :permanent="$vuetify.display.mdAndUp">
      <ChatLeftSidebarContent v-model:is-drawer-open="isLeftSidebarOpen" v-model:search="q" 
        show-current-user-avatar
        :show-conatcts="false"
        show-first-message :show-user-avatar="false" :show-user-name="false" show-new-conversation
        @new-chat="newConversation" @open-chat="$event => openChatOfContact($event)"
        @show-user-profile="isUserProfileSidebarOpen = true" @close="isLeftSidebarOpen = false" />
    </VNavigationDrawer> -->

    <!-- 👉 Chat content -->
    <VMain class="chat-content-container">
      
      <!-- 👉 Right content: Active Chat -->
      <div  class="d-flex flex-column justify-space-between ga-1 h-100">
        <!-- 👉 Active chat header -->
        <!-- <div class="active-chat-header d-flex align-center text-medium-emphasis bg-surface"> -->
          <!-- Sidebar toggler -->
          <!-- <IconBtn class="d-md-none me-3" @click="isLeftSidebarOpen = true">
            <VIcon icon="tabler-menu-2" />
          </IconBtn> -->

          <!-- avatar -->
          <!-- <div class="d-flex align-center cursor-pointer" @click="isActiveChatUserProfileSidebarOpen = true">
            <VBadge dot location="bottom right" offset-x="3" offset-y="0"
              :color="resolveAvatarBadgeVariant(store.activeChat.contact.status)" bordered>
              <VAvatar size="40" :variant="!store.activeChat.contact.avatar ? 'tonal' : undefined"
                :color="!store.activeChat.contact.avatar ? resolveAvatarBadgeVariant(store.activeChat.contact.status) : undefined"
                class="cursor-pointer">
                <VImg v-if="store.activeChat.contact.avatar" :src="store.activeChat.contact.avatar"
                  :alt="store.activeChat.contact.fullName" />
                <span v-else>{{ avatarText(store.activeChat.contact.fullName) }}</span>
              </VAvatar>
            </VBadge>

            <div class="flex-grow-1 ms-4 overflow-hidden">
              <div class="text-h6 mb-0 font-weight-regular">
                {{ store.activeChat.contact.fullName }}
              </div>
              <p class="text-truncate mb-0 text-body-2">
                {{ store.activeChat.contact.role }}
              </p>
            </div>
          </div> -->

          <!-- <VSpacer /> -->

          <!-- Header right content -->
          <!-- <div class="d-sm-flex align-center d-none text-medium-emphasis">
            <IconBtn>
              <VIcon icon="tabler-phone" />
            </IconBtn>
            <IconBtn>
              <VIcon icon="tabler-video" />
            </IconBtn>
            <IconBtn>
              <VIcon icon="tabler-search" />
            </IconBtn>
            <IconBtn>
              <VIcon icon="tabler-dots-vertical" />
            </IconBtn>
          </div> -->
        <!-- </div> -->

        <!-- <VDivider /> -->
        <!-- Chat log -->
        <PerfectScrollbar v-if="store.activeChat" ref="chatLogPS" tag="ul" :options="{ wheelPropagation: false }" class="flex-grow-1">
          <ChatLog :minimum-mode="props.minimumMode" :bot-id="botId" :bg-color="props.bgColor"/>
        </PerfectScrollbar>

        <div  v-if="!store.activeChat" class="d-flex align-center justify-center">
          <!-- <VAvatar size="98" variant="tonal" color="primary" class="mb-4">
            <VIcon size="50" class="rounded-0" icon="tabler-message-2" />
          </VAvatar> -->

          <img height="100px" :src="chatLogo"/>


          <!-- <VBtn v-if="$vuetify.display.smAndDown" :disabled="!store.profileUser" rounded="pill" @click="newConversation">
            <span v-if="store.profileUser">{{ $t("Start Conversation") }}</span>
            <span v-if="!store.profileUser">{{ $t("please wait") }}</span>
          </VBtn> -->

          <div style="max-inline-size: 40ch ;text-wrap:balance" class="text-center">
            <!-- {{ $t("Click the new conversation button to start the conversation") }} -->
            <p>{{ $t("I am Faradid, your personal assistant") }}</p>
            <h4>{{ $t("If you have any questions, I'd be happy to answer.") }}</h4>
          </div>
        </div>

        <ChatRecommendations v-if="recommends && recommends!=[] && recommends.length>0 && store.currentTypedText=='' && !store.activeChat?.chat?.messages?.length" class="mb-4" :recommends="recommends[0].questions" :reciever-id="bot.userId"/>
          
      
        <ChatMessageForm class="align-end" show-feedback-mode-btn :minimum-mode="props.minimumMode"  :reciever-id="bot.userId" @send-message="messageSent" />
      </div>

      <!-- 👉 Start conversation -->
      <!-- <div class="d-flex h-100 align-center flex-column"> -->
      
      <!-- <ChatMessageForm show-feedback-mode-btn :reciever-id="bot.userId" @send-message="messageSent" /> -->
    <!-- </div> -->
    </VMain>

    <ConnectionLostDialog 
      v-model="isConnectionLost" 
      :connecting="connectingToSocket"
      :reconnect-timer="reconnectTimer"
      :max-reconnect-time="maxReconnectTime"
      @reconnect="handleManualReconnect"
    />
    <DuplicateClientDialog v-model="duplicateClientOpened" />
  </VLayout>
</template>

<style lang="scss">
@use "@styles/variables/vuetify";
@use "@core/scss/base/mixins";
@use "@layouts/styles/mixins" as layoutsMixins;

// Variables
$chat-app-header-height: 76px;

// Placeholders
%chat-header {
  display: flex;
  align-items: center;
  min-block-size: $chat-app-header-height;
  padding-inline: 1.5rem;
}

.chat-start-conversation-btn {
  cursor: default;
}

.chat-app-layout {
  border-radius: vuetify.$card-border-radius;

  @include mixins.elevation(vuetify.$card-elevation);

  $sel-chat-app-layout: &;

  @at-root {
    .skin--bordered {
      @include mixins.bordered-skin($sel-chat-app-layout);
    }
  }

  .active-chat-user-profile-sidebar,
  .user-profile-sidebar {
    .v-navigation-drawer__content {
      display: flex;
      flex-direction: column;
    }
  }

  .chat-list-header,
  .active-chat-header {
    @extend %chat-header;
  }

  .chat-list-sidebar {
    .v-navigation-drawer__content {
      display: flex;
      flex-direction: column;
    }
  }
}

.chat-content-container {
  /* stylelint-disable-next-line value-keyword-case */
  background-color: v-bind(chatContentContainerBg);

  // Adjust the padding so text field height stays 48px
  .chat-message-input {
    .v-field__input {
      font-size: 0.9375rem !important;
      line-height: 1.375rem !important;
      padding-block: 0.6rem 0.5rem;
    }

    .v-field__append-inner {
      align-items: center;
      padding-block-start: 0;
    }

    .v-field--appended {
      padding-inline-end: 8px;
    }
  }
}

.chat-user-profile-badge {
  .v-badge__badge {
    /* stylelint-disable liberty/use-logical-spec */
    min-width: 12px !important;
    height: 0.75rem;
    /* stylelint-enable liberty/use-logical-spec */
  }
}
</style>
